// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import API_URL from "../../../src/Config";
// import Tooltip from "@mui/material/Tooltip";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import { FiPlus } from "react-icons/fi";
// import { AiOutlineClose } from "react-icons/ai";
// import Select from "react-select";
// import { IoMdArrowBack } from "react-icons/io";
// import "./BOQForm.css";

// function BOQForm({ isSidebarExpanded }) {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [poData, setPoData] = useState({
//     project_id: "",
//   });
//   const [rows, setRows] = useState([]);
//   const [boqDetail, setBoqDetail] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [severity, setSeverity] = useState("success");
//   const [openActionIndex, setOpenActionIndex] = useState(null);
//   const actionMenuRef = useRef(null);
//   const [dataFetched, setDataFetched] = useState(false);

//   // Schedule preview modal states
//   const [previewModalOpen, setPreviewModalOpen] = useState(false);
//   const [previewData, setPreviewData] = useState(null);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   // Generate schedule confirmation modal states
//   const [generateModalOpen, setGenerateModalOpen] = useState(false);
//   const [selectedServiceCode, setSelectedServiceCode] = useState("");
//   const [generateLoading, setGenerateLoading] = useState(false);
//   const [regenerateOption, setRegenerateOption] = useState(false);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         actionMenuRef.current &&
//         !actionMenuRef.current.contains(event.target)
//       ) {
//         setOpenActionIndex(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const unitOptions = [
//     { value: "centimeter", label: "Centimeter (cm)" },
//     { value: "day", label: "Day" },
//     { value: "gram", label: "Gram (g)" },
//     { value: "inch", label: "Inch (in)" },
//     { value: "kg", label: "Kilogram (kg)" },
//     { value: "kilometer", label: "Kilometer (km)" },
//     { value: "liters", label: "Liters (L)" },
//     { value: "m", label: "Meter (m)" },
//     { value: "milligram", label: "Milligram (mg)" },
//     { value: "millimeter", label: "Millimeter (mm)" },
//     { value: "month", label: "Month" },
//     { value: "numbers", label: "Numbers (nos)" },
//     { value: "pcs", label: "Pieces (pcs)" },
//     { value: "visit", label: "Visit" },
//     { value: "year", label: "Year" },
//   ];

//   // Helper function to create a default empty row
//   const createEmptyRow = () => ({
//     service_code: "",
//     description: "",
//     uom: "",
//     qty: 1,
//     unit_rate: 0.00,
//     gst: 18,
//     total_detectors: 0,
//     isSaved: false,
//   });

//   const fetchData = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");

//       // Fetch BOQ details
//       const boqResponse = await axios.get(`${API_URL}/api/get_amc_boqs`, {
//         headers: { Authorization: authKey },
//         params: { project_id: id },
//       });

//       const boqs = boqResponse.data.BOQs || [];

//       // Store in both states if you need `boqDetail` separately
//       setBoqDetail(boqs);

//       const mappedRows = boqs.map((item) => ({
//         service_code: item.service_code || "",
//         description: item.description || "",
//         uom: item.uom || "",
//         qty: item.qty ?? 1,
//         unit_rate: item.unit_rate ?? 0.00,
//         gst: item.gst ?? 18,
//         total_detectors: item.total_detectors ?? 0,
//         isSaved: true,
//       }));

//       // If no data exists, add a default empty row
//       if (mappedRows.length === 0) {
//         setRows([createEmptyRow()]);
//       } else {
//         // Add a new default row after saved rows
//         setRows([...mappedRows, createEmptyRow()]);
//       }

//       setDataFetched(true);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       // Even on error, add a default row if no data exists
//       if (rows.length === 0) {
//         setRows([createEmptyRow()]);
//       }
//       setDataFetched(true);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       fetchData();
//     }
//   }, [id]);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const handleInputChanges = (index, field, value) => {
//     const updatedRows = [...rows];
//     updatedRows[index][field] = value;
//     setRows(updatedRows);
//   };

//   const handleAddRow = () => {
//     setRows([...rows, createEmptyRow()]);
//   };

//   const handleRemoveRow = (index) => {
//     // Check if this is the only unsaved row
//     const unsavedRows = rows.filter(row => !row.isSaved);
    
//     if (unsavedRows.length === 1 && !rows[index].isSaved) {
//       showSnackbar("At least one empty row must be present for adding new entries", "warning");
//       return;
//     }
    
//     setRows(rows.filter((_, i) => i !== index));
//   };

//   const showSnackbar = (message, severityType = "success") => {
//     setSnackbarMessage(message);
//     setSeverity(severityType);
//     setSnackbarOpen(true);
//   };

//   const handleSaveClick = async () => {
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       // Filter only unsaved rows
//       const unsavedRows = rows.filter((row) => !row.isSaved);

//       if (unsavedRows.length === 0) {
//         showSnackbar("No new rows to save", "info");
//         setIsLoading(false);
//         return;
//       }

//       // Validate required fields (description is now optional)
//       const hasEmptyFields = unsavedRows.some(
//         (row) =>
//           !row.service_code.trim() ||
//           !row.uom ||
//           row.qty === "" ||
//           row.qty === null ||
//           row.unit_rate === "" ||
//           row.unit_rate === null ||
//           row.gst === "" ||
//           row.gst === null
//       );

//       if (hasEmptyFields) {
//         showSnackbar("Please fill all required fields (Service Code, UOM, Quantity, Unit Rate, GST) in new rows", "error");
//         setIsLoading(false);
//         return;
//       }

//       // Validate numeric fields
//       const hasInvalidNumbers = unsavedRows.some(
//         (row) =>
//           isNaN(Number(row.qty)) ||
//           isNaN(Number(row.unit_rate)) ||
//           isNaN(Number(row.gst)) ||
//           Number(row.qty) <= 0 ||
//           Number(row.unit_rate) < 0 ||
//           Number(row.gst) < 0
//       );

//       if (hasInvalidNumbers) {
//         showSnackbar("Please enter valid numbers: quantity must be greater than 0, unit rate and GST must be non-negative", "error");
//         setIsLoading(false);
//         return;
//       }

//       const boqPayload = {
//         project_id: id,
//         boq_list: unsavedRows.map((row) => ({
//           service_code: row.service_code.trim(),
//           description: row.description.trim(), // Optional, can be empty string
//           uom: row.uom,
//           qty: Number(row.qty),
//           unit_rate: Number(row.unit_rate),
//           gst: Number(row.gst),
//         })),
//       };

//       const response = await axios.post(
//         `${API_URL}/api/add_amc_boq_bulk`,
//         boqPayload,
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         showSnackbar("BOQ added successfully", "success");
//         // Refresh data to get all saved rows with a new default row
//         await fetchData();
//       }
//     } catch (error) {
//       console.error("Error adding BOQ:", error.message);
//       showSnackbar(error.response?.data?.error || "Failed to add BOQ", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancelClick = () => {
//     navigate("/amc-projects");
//   };

//   const fetchAuditData = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_amc_project/${id}`, {
//         headers: { Authorization: authKey },
//       });

//       const responseData = response.data;

//       // Format and set project data
//       const formattedData = {
//         company_id: responseData.company_id || "",
//         created_at: responseData.created_at
//           ? new Date(responseData.created_at).toLocaleDateString("en-GB")
//           : "N/A",
//         customer_id: responseData.customer_id || "",
//         customer_location: responseData.customer_location || "",
//         customer_name: responseData.customer_name || "",
//         end_date: responseData.end_date
//           ? new Date(responseData.end_date).toLocaleDateString("en-GB")
//           : "N/A",
//         project_id: responseData.id || "",
//         isArchive: responseData.isArchive ? "Yes" : "No",
//         location_id: responseData.location_id || "N/A",
//         po_number: responseData.po_number || "",
//         project_name: responseData.project_name || "",
//         billing_frequency: responseData.billing_frequency || "",
//         project_type: responseData.project_type || "",
//         project_type_id: responseData.project_type_id || "",
//         start_date: responseData.start_date
//           ? new Date(responseData.start_date).toLocaleDateString("en-GB")
//           : "N/A",
//         updated_at: responseData.updated_at
//           ? new Date(responseData.updated_at).toLocaleDateString("en-GB")
//           : "N/A",
//       };

//       setPoData(formattedData);
//     } catch (error) {
//       console.error("Error fetching project data:", error.message);
//       showSnackbar("Failed to fetch project data", "error");
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       fetchAuditData();
//     }
//   }, [id]);

//   const handleBackProject = () => {
//     navigate("/amc-projects");
//   };

//   // Handle View Schedule Preview
//   const handleViewSchedule = async (serviceCode) => {
//     try {
//       setPreviewLoading(true);
//       setPreviewModalOpen(true);
//       setOpenActionIndex(null);

//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.post(
//         `${API_URL}/api/gas_detector_schedule_preview`,
//         {
//           service_code: serviceCode,
//           project_id: id,
//         },
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setPreviewData(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching schedule preview:", error);
//       showSnackbar(
//         error.response?.data?.error || "Failed to fetch schedule preview",
//         "error"
//       );
//       setPreviewModalOpen(false);
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   // Handle Generate Schedule
//   const handleGenerateScheduleClick = (serviceCode) => {
//     setSelectedServiceCode(serviceCode);
//     setGenerateModalOpen(true);
//     setOpenActionIndex(null);
//     setRegenerateOption(false);
//   };

//   const handleGenerateScheduleConfirm = async () => {
//     try {
//       setGenerateLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.post(
//         `${API_URL}/api/generate_gas_detector_schedule_bulk`,
//         {
//           service_code: selectedServiceCode,
//           project_id: id,
//           regenerate: regenerateOption,
//         },
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         showSnackbar(
//           `Schedule generated successfully for ${response.data.summary.total_detectors} detectors`,
//           "success"
//         );
//         setGenerateModalOpen(false);
//         await fetchData(); // Refresh data
//       }
//     } catch (error) {
//       console.error("Error generating schedule:", error);
//       showSnackbar(
//         error.response?.data?.error || "Failed to generate schedule",
//         "error"
//       );
//     } finally {
//       setGenerateLoading(false);
//     }
//   };

//   const handleClosePreviewModal = () => {
//     setPreviewModalOpen(false);
//     setPreviewData(null);
//   };

//   const handleCloseGenerateModal = () => {
//     setGenerateModalOpen(false);
//     setSelectedServiceCode("");
//     setRegenerateOption(false);
//   };

//   return (
//     <>
//       <div
//         className={`data-form-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-form-content">
//           <div className="data-form-header">
//             <div className="data-form-header-content">
//               <div className="data-form-heading-content-left-side">
//                 <Tooltip title="Back" arrow>
//                   <IoMdArrowBack
//                     className="back-company"
//                     onClick={handleBackProject}
//                   />
//                 </Tooltip>
//                 BOQ List Item
//               </div>

//               <div className="data-form-heading-content-right-side"></div>
//             </div>
//           </div>
//           <div className="header-separator"></div>
//           <div className="data-form-body">
//             <div className="action-purchase-header">
//               <div className="project-detailss">
//                 <div className="project-detail-arround">
//                   <div className="project-details-left-side-audit">
//                     <div className="project-detail">
//                       <div className="detail-header">Project Name:</div>
//                       <div className="detail-part">
//                         {poData.project_name || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">Customer Name:</div>
//                       <div className="detail-part">
//                         {poData.customer_name || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">PO Number:</div>
//                       <div className="detail-part">
//                         {poData.po_number || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">Project Type:</div>
//                       <div className="detail-part">
//                         {poData.project_type || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">Start Date:</div>
//                       <div className="detail-part">
//                         {poData.start_date || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">End Date:</div>
//                       <div className="detail-part">
//                         {poData.end_date || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">Location:</div>
//                       <div className="detail-part">
//                         {poData.customer_location || "N/A"}
//                       </div>
//                     </div>
//                     <div className="project-detail">
//                       <div className="detail-header">Frequency:</div>
//                       <div className="detail-part">
//                         {poData.billing_frequency || "N/A"}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="action-purchase-sheet-header">
//               <div className="actions-purchase-sheet-header-content">
//                 <div className="actions-purchase-sheet-heading-content-left-side">
//                   BOQ ITEM LIST
//                 </div>
//               </div>
//             </div>

//             <div className="action-purchase-body">
//               <div className="action-purchase-scroll-body">
//                 <div className="action-purchase-tabless">
//                   <table className="action-table action-multilevel-data">
//                     <thead className="action-purchase-heads">
//                       <tr>
//                         <th className="b-th1">SERVICE CODE *</th>
//                         <th className="b-th2">DESCRIPTION</th>
//                         <th className="b-th3">UOM *</th>
//                         <th className="b-th4">QTY *</th>
//                         <th className="b-th5">UNIT RATE *</th>
//                         <th className="b-th5">GST (%) *</th>
//                         <th className="b-th5">TOTAL DETECTORS</th>
//                         <th className="b-th6">ACTION</th>
//                       </tr>
//                     </thead>

//                     <tbody className="action-purchase-scroll-bodys-pr">
//                       {rows.map((row, index) => (
//                         <tr key={index}>
//                           <td className="b-th1">
//                             <input
//                               type="text"
//                               value={row.service_code}
//                               onChange={(e) =>
//                                 handleInputChanges(
//                                   index,
//                                   "service_code",
//                                   e.target.value
//                                 )
//                               }
//                               placeholder="Enter Service Code"
//                               disabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th2">
//                             <input
//                               type="text"
//                               value={row.description}
//                               onChange={(e) =>
//                                 handleInputChanges(
//                                   index,
//                                   "description",
//                                   e.target.value
//                                 )
//                               }
//                               placeholder="Enter Description (Optional)"
//                               disabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th3">
//                             <Select
//                               options={unitOptions}
//                               value={unitOptions.find(
//                                 (option) => option.value === row.uom
//                               )}
//                               onChange={(selectedOption) =>
//                                 handleInputChanges(
//                                   index,
//                                   "uom",
//                                   selectedOption?.value || ""
//                                 )
//                               }
//                               placeholder="Select Unit"
//                               isDisabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th4">
//                             <input
//                               type="number"
//                               min="1"
//                               step="any"
//                               value={row.qty}
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 handleInputChanges(
//                                   index,
//                                   "qty",
//                                   value === "" ? "" : value
//                                 );
//                               }}
//                               placeholder="Enter Quantity"
//                               disabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th5">
//                             <input
//                               type="number"
//                               min="0"
//                               step="0.01"
//                               value={row.unit_rate}
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 handleInputChanges(
//                                   index,
//                                   "unit_rate",
//                                   value === "" ? "" : value
//                                 );
//                               }}
//                               placeholder="Enter Unit Rate"
//                               disabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th5">
//                             <input
//                               type="number"
//                               min="0"
//                               max="100"
//                               step="any"
//                               value={row.gst}
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 handleInputChanges(
//                                   index,
//                                   "gst",
//                                   value === "" ? "" : value
//                                 );
//                               }}
//                               placeholder="Enter GST"
//                               disabled={row.isSaved}
//                             />
//                           </td>

//                           <td className="b-th5">{row.total_detectors}</td>

//                           <td className="b-th6">
//                             {!row.isSaved ? (
//                               // Show remove button for new unsaved rows
//                               <button
//                                 className="new_boq_remove_row_button"
//                                 onClick={() => handleRemoveRow(index)}
//                                 title="Remove"
//                               >
//                                 <AiOutlineClose />
//                               </button>
//                             ) : (
//                               // Show action menu for saved rows
//                               <div
//                                 className="new_boq_action_container"
//                                 ref={
//                                   openActionIndex === index
//                                     ? actionMenuRef
//                                     : null
//                                 }
//                               >
//                                 <button
//                                   className="new_boq_action_trigger"
//                                   onClick={() =>
//                                     setOpenActionIndex(
//                                       openActionIndex === index ? null : index
//                                     )
//                                   }
//                                 >
//                                   &#8942;
//                                 </button>

//                                 {openActionIndex === index && (
//                                   <div className="new_boq_action_menu">
//                                     <button
//                                       className="new_boq_action_item new_boq_action_delete"
//                                       onClick={() => {
//                                         // Handle delete for saved rows
//                                         console.log("Delete row:", row);
//                                         showSnackbar(
//                                           "Delete functionality needs to be implemented",
//                                           "info"
//                                         );
//                                         setOpenActionIndex(null);
//                                       }}
//                                     >
//                                       Delete
//                                     </button>

//                                     <button
//                                       className="new_boq_action_item new_boq_action_schedule"
//                                       onClick={() =>
//                                         handleViewSchedule(row.service_code)
//                                       }
//                                     >
//                                       View Schedule
//                                     </button>

//                                     <button
//                                       className="new_boq_action_item new_boq_action_generate"
//                                       onClick={() =>
//                                         handleGenerateScheduleClick(
//                                           row.service_code
//                                         )
//                                       }
//                                     >
//                                       Generate Schedule
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>

//                   <div className="row">
//                     <div className="action-caluculation">
//                       <div className="new-rows">
//                         <button onClick={handleAddRow} className="add-rows">
//                           <FiPlus className="add-row-icon" /> Add New Row
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="footer">
//             <div className="button-group">
//               <button
//                 className="data-form-save-button"
//                 type="button"
//                 onClick={handleSaveClick}
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Saving..." : "Save"}
//               </button>

//               <button
//                 className="data-form-cancel-button"
//                 onClick={handleCancelClick}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Schedule Preview Modal */}
//       <Dialog
//         open={previewModalOpen}
//         onClose={handleClosePreviewModal}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Schedule Preview - {previewData?.service_code}
//         </DialogTitle>
//         <DialogContent>
//           {previewLoading ? (
//             <div className="modal-loading">Loading preview...</div>
//           ) : previewData ? (
//             <div className="schedule-preview-container">
//               <div className="preview-section">
//                 <h3>Project Information</h3>
//                 <div className="preview-grid">
//                   <div className="preview-item">
//                     <span className="preview-label">Project Name:</span>
//                     <span className="preview-value">
//                       {previewData.project_name}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">BOQ Description:</span>
//                     <span className="preview-value">
//                       {previewData.boq_description}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">BOQ Quantity:</span>
//                     <span className="preview-value">{previewData.boq_qty}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="preview-section">
//                 <h3>Detector Information</h3>
//                 <div className="preview-grid">
//                   <div className="preview-item">
//                     <span className="preview-label">Total Detectors:</span>
//                     <span className="preview-value">
//                       {previewData.total_detectors}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Active Detectors:</span>
//                     <span className="preview-value">
//                       {previewData.active_detectors}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Inactive Detectors:</span>
//                     <span className="preview-value">
//                       {previewData.inactive_detectors}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Frequency (Days):</span>
//                     <span className="preview-value">
//                       {previewData.frequency_days}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Already Scheduled:</span>
//                     <span className="preview-value">
//                       {previewData.detectors_already_scheduled}
//                     </span>
//                   </div>
//                 </div>
//                 {previewData.frequency_warning && (
//                   <div className="preview-warning">
//                     ⚠️ {previewData.frequency_warning}
//                   </div>
//                 )}
//               </div>

//               <div className="preview-section">
//                 <h3>Schedule Information</h3>
//                 <div className="preview-grid">
//                   <div className="preview-item">
//                     <span className="preview-label">
//                       Schedules Per Detector (Possible):
//                     </span>
//                     <span className="preview-value">
//                       {previewData.possible_schedules_per_detector}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">
//                       Schedules Per Detector (Allowed by BOQ):
//                     </span>
//                     <span className="preview-value">
//                       {previewData.schedules_per_detector_allowed}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">
//                       Total Schedules to Generate:
//                     </span>
//                     <span className="preview-value">
//                       {previewData.total_schedules_to_generate}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Within BOQ Schedules:</span>
//                     <span className="preview-value preview-success">
//                       {previewData.within_boq_schedules}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Extra Schedules:</span>
//                     <span className="preview-value preview-warning">
//                       {previewData.extra_schedules}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div className="preview-section">
//                 <h3>Project Tenure</h3>
//                 <div className="preview-grid">
//                   <div className="preview-item">
//                     <span className="preview-label">Start Date:</span>
//                     <span className="preview-value">
//                       {new Date(
//                         previewData.project_tenure.start_date
//                       ).toLocaleDateString("en-GB")}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">End Date:</span>
//                     <span className="preview-value">
//                       {new Date(
//                         previewData.project_tenure.end_date
//                       ).toLocaleDateString("en-GB")}
//                     </span>
//                   </div>
//                   <div className="preview-item">
//                     <span className="preview-label">Duration (Days):</span>
//                     <span className="preview-value">
//                       {previewData.project_tenure.duration_days}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ) : null}
//         </DialogContent>
//         <DialogActions>
//           <button
//             onClick={handleClosePreviewModal}
//             className="modal-button modal-button-secondary"
//           >
//             Close
//           </button>
//         </DialogActions>
//       </Dialog>

//       {/* Generate Schedule Confirmation Modal */}
//       <Dialog
//         open={generateModalOpen}
//         onClose={handleCloseGenerateModal}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Generate Schedule</DialogTitle>
//         <DialogContent>
//           <div className="generate-schedule-modal">
//             <p>
//               Are you sure you want to generate schedule for service code:{" "}
//               <strong>{selectedServiceCode}</strong>?
//             </p>

//             <div className="regenerate-option">
//               <label>
//                 <input
//                   type="checkbox"
//                   checked={regenerateOption}
//                   onChange={(e) => setRegenerateOption(e.target.checked)}
//                 />
//                 <span>
//                   Regenerate (This will delete existing schedules and create new
//                   ones)
//                 </span>
//               </label>
//             </div>
//             {regenerateOption && (
//               <div className="regenerate-warning">
//                 ⚠️ Warning: Existing schedules will be permanently deleted!
//               </div>
//             )}
//           </div>
//         </DialogContent>
//         <DialogActions>
//           <button
//             onClick={handleCloseGenerateModal}
//             className="modal-button modal-button-secondary"
//             disabled={generateLoading}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleGenerateScheduleConfirm}
//             className="modal-button modal-button-primary"
//             disabled={generateLoading}
//           >
//             {generateLoading ? "Generating..." : "Generate"}
//           </button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={15000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ transform: "translateY(50px)", marginLeft: "25px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default BOQForm;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../../src/Config";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { FiPlus } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import Select from "react-select";
import { IoMdArrowBack } from "react-icons/io";
import "./BOQForm.css";

function BOQForm({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [poData, setPoData] = useState({
    project_id: "",
  });
  const [rows, setRows] = useState([]);
  const [boqDetail, setBoqDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [openActionIndex, setOpenActionIndex] = useState(null);
  const actionMenuRef = useRef(null);
  const [dataFetched, setDataFetched] = useState(false);

  // Generate schedule modal states
  const [generateModalOpen, setGenerateModalOpen] = useState(false);
  const [selectedServiceCode, setSelectedServiceCode] = useState("");
  const [generateLoading, setGenerateLoading] = useState(false);
  const [regenerateOption, setRegenerateOption] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        setOpenActionIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const unitOptions = [
    { value: "centimeter", label: "Centimeter (cm)" },
    { value: "day", label: "Day" },
    { value: "gram", label: "Gram (g)" },
    { value: "inch", label: "Inch (in)" },
    { value: "kg", label: "Kilogram (kg)" },
    { value: "kilometer", label: "Kilometer (km)" },
    { value: "liters", label: "Liters (L)" },
    { value: "m", label: "Meter (m)" },
    { value: "milligram", label: "Milligram (mg)" },
    { value: "millimeter", label: "Millimeter (mm)" },
    { value: "month", label: "Month" },
    { value: "numbers", label: "Numbers (nos)" },
    { value: "pcs", label: "Pieces (pcs)" },
    { value: "visit", label: "Visit" },
    { value: "year", label: "Year" },
  ];

  // Helper function to create a default empty row
  const createEmptyRow = () => ({
    service_code: "",
    description: "",
    uom: "",
    qty: 1,
    unit_rate: 0.0,
    gst: 18,
    total_detectors: 0,
    isSaved: false,
  });

  const fetchData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      // Fetch BOQ details
      const boqResponse = await axios.get(`${API_URL}/api/get_amc_boqs`, {
        headers: { Authorization: authKey },
        params: { project_id: id },
      });

      const boqs = boqResponse.data.BOQs || [];

      // Store in both states if you need `boqDetail` separately
      setBoqDetail(boqs);

      const mappedRows = boqs.map((item) => ({
        service_code: item.service_code || "",
        description: item.description || "",
        uom: item.uom || "",
        qty: item.qty ?? 1,
        unit_rate: item.unit_rate ?? 0.0,
        gst: item.gst ?? 18,
        total_detectors: item.total_detectors ?? 0,
        isSaved: true,
      }));

      // If no data exists, add a default empty row
      if (mappedRows.length === 0) {
        setRows([createEmptyRow()]);
      } else {
        // Add a new default row after saved rows
        setRows([...mappedRows, createEmptyRow()]);
      }

      setDataFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      // Even on error, add a default row if no data exists
      if (rows.length === 0) {
        setRows([createEmptyRow()]);
      }
      setDataFetched(true);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleInputChanges = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([...rows, createEmptyRow()]);
  };

  const handleRemoveRow = (index) => {
    // Check if this is the only unsaved row
    const unsavedRows = rows.filter((row) => !row.isSaved);

    if (unsavedRows.length === 1 && !rows[index].isSaved) {
      showSnackbar(
        "At least one empty row must be present for adding new entries",
        "warning"
      );
      return;
    }

    setRows(rows.filter((_, i) => i !== index));
  };

  const showSnackbar = (message, severityType = "success") => {
    setSnackbarMessage(message);
    setSeverity(severityType);
    setSnackbarOpen(true);
  };

  const handleSaveClick = async () => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Filter only unsaved rows
      const unsavedRows = rows.filter((row) => !row.isSaved);

      if (unsavedRows.length === 0) {
        showSnackbar("No new rows to save", "info");
        setIsLoading(false);
        return;
      }

      // Validate required fields (description is now optional)
      const hasEmptyFields = unsavedRows.some(
        (row) =>
          !row.service_code.trim() ||
          !row.uom ||
          row.qty === "" ||
          row.qty === null ||
          row.unit_rate === "" ||
          row.unit_rate === null ||
          row.gst === "" ||
          row.gst === null
      );

      if (hasEmptyFields) {
        showSnackbar(
          "Please fill all required fields (Service Code, UOM, Quantity, Unit Rate, GST) in new rows",
          "error"
        );
        setIsLoading(false);
        return;
      }

      // Validate numeric fields
      const hasInvalidNumbers = unsavedRows.some(
        (row) =>
          isNaN(Number(row.qty)) ||
          isNaN(Number(row.unit_rate)) ||
          isNaN(Number(row.gst)) ||
          Number(row.qty) <= 0 ||
          Number(row.unit_rate) < 0 ||
          Number(row.gst) < 0
      );

      if (hasInvalidNumbers) {
        showSnackbar(
          "Please enter valid numbers: quantity must be greater than 0, unit rate and GST must be non-negative",
          "error"
        );
        setIsLoading(false);
        return;
      }

      const boqPayload = {
        project_id: id,
        boq_list: unsavedRows.map((row) => ({
          service_code: row.service_code.trim(),
          description: row.description.trim(), // Optional, can be empty string
          uom: row.uom,
          qty: Number(row.qty),
          unit_rate: Number(row.unit_rate),
          gst: Number(row.gst),
        })),
      };

      const response = await axios.post(
        `${API_URL}/api/add_amc_boq_bulk`,
        boqPayload,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        showSnackbar("BOQ added successfully", "success");
        // Refresh data to get all saved rows with a new default row
        await fetchData();
      }
    } catch (error) {
      console.error("Error adding BOQ:", error.message);
      showSnackbar(
        error.response?.data?.error || "Failed to add BOQ",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelClick = () => {
    navigate("/amc-projects");
  };

  const fetchAuditData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_amc_project/${id}`, {
        headers: { Authorization: authKey },
      });

      const responseData = response.data;

      // Format and set project data
      const formattedData = {
        company_id: responseData.company_id || "",
        created_at: responseData.created_at
          ? new Date(responseData.created_at).toLocaleDateString("en-GB")
          : "N/A",
        customer_id: responseData.customer_id || "",
        customer_location: responseData.customer_location || "",
        customer_name: responseData.customer_name || "",
        end_date: responseData.end_date
          ? new Date(responseData.end_date).toLocaleDateString("en-GB")
          : "N/A",
        project_id: responseData.id || "",
        isArchive: responseData.isArchive ? "Yes" : "No",
        location_id: responseData.location_id || "N/A",
        po_number: responseData.po_number || "",
        project_name: responseData.project_name || "",
        billing_frequency: responseData.billing_frequency || "",
        project_type: responseData.project_type || "",
        project_type_id: responseData.project_type_id || "",
        start_date: responseData.start_date
          ? new Date(responseData.start_date).toLocaleDateString("en-GB")
          : "N/A",
        updated_at: responseData.updated_at
          ? new Date(responseData.updated_at).toLocaleDateString("en-GB")
          : "N/A",
      };

      setPoData(formattedData);
    } catch (error) {
      console.error("Error fetching project data:", error.message);
      showSnackbar("Failed to fetch project data", "error");
    }
  };

  useEffect(() => {
    if (id) {
      fetchAuditData();
    }
  }, [id]);

  const handleBackProject = () => {
    navigate("/amc-projects");
  };

  // Handle Generate Schedule - First fetch preview, then show modal
  const handleGenerateScheduleClick = async (serviceCode) => {
    try {
      setSelectedServiceCode(serviceCode);
      setPreviewLoading(true);
      setGenerateModalOpen(true);
      setOpenActionIndex(null);
      setRegenerateOption(false);
      setPreviewData(null);

      const authKey = localStorage.getItem("authKey");
      const response = await axios.post(
        `${API_URL}/api/gas_detector_schedule_preview`,
        {
          service_code: serviceCode,
          project_id: id,
        },
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setPreviewData(response.data);
      }
    } catch (error) {
      console.error("Error fetching schedule preview:", error);
      showSnackbar(
        error.response?.data?.error || "Failed to fetch schedule preview",
        "error"
      );
      setGenerateModalOpen(false);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleGenerateScheduleConfirm = async () => {
    try {
      setGenerateLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.post(
        `${API_URL}/api/generate_gas_detector_schedule_bulk`,
        {
          service_code: selectedServiceCode,
          project_id: id,
          regenerate: regenerateOption,
        },
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        showSnackbar(
          `Schedule generated successfully for ${response.data.summary.total_detectors} detectors`,
          "success"
        );
        setGenerateModalOpen(false);
        await fetchData(); // Refresh data
      }
    } catch (error) {
      console.error("Error generating schedule:", error);
      showSnackbar(
        error.response?.data?.error || "Failed to generate schedule",
        "error"
      );
    } finally {
      setGenerateLoading(false);
    }
  };

  const handleCloseGenerateModal = () => {
    setGenerateModalOpen(false);
    setSelectedServiceCode("");
    setRegenerateOption(false);
    setPreviewData(null);
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <div className="data-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBackProject}
                  />
                </Tooltip>
                BOQ List Item
              </div>

              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <div className="action-purchase-header">
              <div className="project-detailss">
                <div className="project-detail-arround">
                  <div className="project-details-left-side-audit">
                    <div className="project-detail">
                      <div className="detail-header">Project Name:</div>
                      <div className="detail-part">
                        {poData.project_name || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">Customer Name:</div>
                      <div className="detail-part">
                        {poData.customer_name || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">PO Number:</div>
                      <div className="detail-part">
                        {poData.po_number || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">Project Type:</div>
                      <div className="detail-part">
                        {poData.project_type || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">Start Date:</div>
                      <div className="detail-part">
                        {poData.start_date || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">End Date:</div>
                      <div className="detail-part">
                        {poData.end_date || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">Location:</div>
                      <div className="detail-part">
                        {poData.customer_location || "N/A"}
                      </div>
                    </div>
                    <div className="project-detail">
                      <div className="detail-header">Frequency:</div>
                      <div className="detail-part">
                        {poData.billing_frequency || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="action-purchase-sheet-header">
              <div className="actions-purchase-sheet-header-content">
                <div className="actions-purchase-sheet-heading-content-left-side">
                  BOQ ITEM LIST
                </div>
              </div>
            </div>

            <div className="action-purchase-body">
              <div className="action-purchase-scroll-body">
                <div className="action-purchase-tabless">
                  <table className="action-table action-multilevel-data">
                    <thead className="action-purchase-heads">
                      <tr>
                        <th className="b-th1">SERVICE CODE *</th>
                        <th className="b-th2">DESCRIPTION</th>
                        <th className="b-th3">UOM *</th>
                        <th className="b-th4">QTY *</th>
                        <th className="b-th5">UNIT RATE *</th>
                        <th className="b-th5">GST (%) *</th>
                        <th className="b-th5">TOTAL DETECTORS</th>
                        <th className="b-th6">ACTION</th>
                      </tr>
                    </thead>

                    <tbody className="action-purchase-scroll-bodys-pr">
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td className="b-th1">
                            <input
                              type="text"
                              value={row.service_code}
                              onChange={(e) =>
                                handleInputChanges(
                                  index,
                                  "service_code",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Service Code"
                              disabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th2">
                            <input
                              type="text"
                              value={row.description}
                              onChange={(e) =>
                                handleInputChanges(
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Description (Optional)"
                              disabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th3">
                            <Select
                              options={unitOptions}
                              value={unitOptions.find(
                                (option) => option.value === row.uom
                              )}
                              onChange={(selectedOption) =>
                                handleInputChanges(
                                  index,
                                  "uom",
                                  selectedOption?.value || ""
                                )
                              }
                              placeholder="Select Unit"
                              isDisabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th4">
                            <input
                              type="number"
                              min="1"
                              step="any"
                              value={row.qty}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleInputChanges(
                                  index,
                                  "qty",
                                  value === "" ? "" : value
                                );
                              }}
                              placeholder="Enter Quantity"
                              disabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th5">
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              value={row.unit_rate}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleInputChanges(
                                  index,
                                  "unit_rate",
                                  value === "" ? "" : value
                                );
                              }}
                              placeholder="Enter Unit Rate"
                              disabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th5">
                            <input
                              type="number"
                              min="0"
                              max="100"
                              step="any"
                              value={row.gst}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleInputChanges(
                                  index,
                                  "gst",
                                  value === "" ? "" : value
                                );
                              }}
                              placeholder="Enter GST"
                              disabled={row.isSaved}
                            />
                          </td>

                          <td className="b-th5">{row.total_detectors}</td>

                          <td className="b-th6">
                            {!row.isSaved ? (
                              // Show remove button for new unsaved rows
                              <button
                                className="new_boq_remove_row_button"
                                onClick={() => handleRemoveRow(index)}
                                title="Remove"
                              >
                                <AiOutlineClose />
                              </button>
                            ) : (
                              // Show action menu for saved rows
                              <div
                                className="new_boq_action_container"
                                ref={
                                  openActionIndex === index
                                    ? actionMenuRef
                                    : null
                                }
                              >
                                <button
                                  className="new_boq_action_trigger"
                                  onClick={() =>
                                    setOpenActionIndex(
                                      openActionIndex === index ? null : index
                                    )
                                  }
                                >
                                  &#8942;
                                </button>

                                {openActionIndex === index && (
                                  <div className="new_boq_action_menu">
                                    <button
                                      className="new_boq_action_item new_boq_action_delete"
                                      onClick={() => {
                                        // Handle delete for saved rows
                                        console.log("Delete row:", row);
                                        showSnackbar(
                                          "Delete functionality needs to be implemented",
                                          "info"
                                        );
                                        setOpenActionIndex(null);
                                      }}
                                    >
                                      Delete
                                    </button>

                                    <button
                                      className="new_boq_action_item new_boq_action_generate"
                                      onClick={() =>
                                        handleGenerateScheduleClick(
                                          row.service_code
                                        )
                                      }
                                    >
                                      Generate Schedule
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="row">
                    <div className="action-caluculation">
                      <div className="new-rows">
                        <button onClick={handleAddRow} className="add-rows">
                          <FiPlus className="add-row-icon" /> Add New Row
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>

              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Generate Schedule Modal with Preview */}
      <Dialog
        open={generateModalOpen}
        onClose={handleCloseGenerateModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Generate Schedule - {selectedServiceCode}</DialogTitle>
        <DialogContent>
          {previewLoading ? (
            <div className="modal-loading">Loading schedule preview...</div>
          ) : previewData ? (
            <div className="generate-schedule-with-preview">
              {/* Preview Section */}
              <div className="schedule-preview-container">
                <div className="preview-section">
                  <h3>Project Information</h3>
                  <div className="preview-grid">
                    <div className="preview-item">
                      <span className="preview-label">Project Name:</span>
                      <span className="preview-value">
                        {previewData.project_name}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">BOQ Description:</span>
                      <span className="preview-value">
                        {previewData.boq_description}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">BOQ Quantity:</span>
                      <span className="preview-value">
                        {previewData.boq_qty}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="preview-section">
                  <h3>Detector Information</h3>
                  <div className="preview-grid">
                    <div className="preview-item">
                      <span className="preview-label">Total Detectors:</span>
                      <span className="preview-value">
                        {previewData.total_detectors}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Active Detectors:</span>
                      <span className="preview-value">
                        {previewData.active_detectors}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Inactive Detectors:</span>
                      <span className="preview-value">
                        {previewData.inactive_detectors}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Frequency (Days):</span>
                      <span className="preview-value">
                        {previewData.frequency_days}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Already Scheduled:</span>
                      <span className="preview-value">
                        {previewData.detectors_already_scheduled}
                      </span>
                    </div>
                  </div>
                  {previewData.frequency_warning && (
                    <div className="preview-warning">
                      ⚠️ {previewData.frequency_warning}
                    </div>
                  )}
                </div>

                <div className="preview-section">
                  <h3>Schedule Information</h3>
                  <div className="preview-grid">
                    <div className="preview-item">
                      <span className="preview-label">
                        Schedules Per Detector (Possible):
                      </span>
                      <span className="preview-value">
                        {previewData.possible_schedules_per_detector}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">
                        Schedules Per Detector (Allowed by BOQ):
                      </span>
                      <span className="preview-value">
                        {previewData.schedules_per_detector_allowed}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">
                        Total Schedules to Generate:
                      </span>
                      <span className="preview-value">
                        {previewData.total_schedules_to_generate}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">
                        Within BOQ Schedules:
                      </span>
                      <span className="preview-value preview-success">
                        {previewData.within_boq_schedules}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Extra Schedules:</span>
                      <span className="preview-value preview-warning">
                        {previewData.extra_schedules}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="preview-section">
                  <h3>Project Tenure</h3>
                  <div className="preview-grid">
                    <div className="preview-item">
                      <span className="preview-label">Start Date:</span>
                      <span className="preview-value">
                        {new Date(
                          previewData.project_tenure.start_date
                        ).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">End Date:</span>
                      <span className="preview-value">
                        {new Date(
                          previewData.project_tenure.end_date
                        ).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-label">Duration (Days):</span>
                      <span className="preview-value">
                        {previewData.project_tenure.duration_days}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Regenerate Option */}
              <div className="generate-options-section">
                <div className="regenerate-option">
                  <label>
                    <input
                      type="checkbox"
                      checked={regenerateOption}
                      onChange={(e) => setRegenerateOption(e.target.checked)}
                    />
                    <span>
                      Regenerate (This will delete existing schedules and create
                      new ones)
                    </span>
                  </label>
                </div>
                {regenerateOption && (
                  <div className="regenerate-warning">
                    ⚠️ Warning: Existing schedules will be permanently deleted!
                  </div>
                )}
              </div>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions>
          <button
            onClick={handleCloseGenerateModal}
            className="modal-button modal-button-secondary"
            disabled={generateLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleGenerateScheduleConfirm}
            className="modal-button modal-button-primary"
            disabled={generateLoading || previewLoading}
          >
            {generateLoading ? "Generating..." : "Generate Schedule"}
          </button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={15000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(50px)", marginLeft: "25px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BOQForm;